import { gql } from '@apollo/client'

export const GET_BOOKING_REPORT = gql`
    query BookingReport($bookingFilter: BookingReportFilterInput!, $page: ReportPageInput!) {
        bookingReport(booking_filter: $bookingFilter, page: $page) {
            code
            success
            message
            total_count
            booking_report {
                location_detail
                return_date
                serial_number
                travel_date
                booking_date
                booking_code
                booking_platform
                booking_type {
                    en
                    ar
                }
                booking_status {
                    en
                    ar
                }
                user_type
                infant_count
                child_count
                adult_count
                senior_count
                vip_count
                std_count
                discount_amount
                net_amount_paid
                gross_ticket_price
                wallet_amount_used
                refund_amount
                refund_date
                receipt_number
                payment_mode
                bk_count_by_daypass
                daypass_code
            }
            total {
                infant_count
                child_count
                adult_count
                senior_count
                vip_count
                std_count
                discount_amount
                net_amount_paid
                gross_ticket_price
                wallet_amount_used
                refund_amount
            }
        }
    }
`

export const SEARCH_LOCATION = gql`
    query SearchLocation($page: PageInput!, $searchLocationId: String, $searchString: String) {
        searchLocation(page: $page, id: $searchLocationId, search_string: $searchString) {
            code
            success
            message
            total_count
            locations {
                id
                name {
                    en
                    ar
                }
            }
        }
    }
`

export const GET_DAYPASS_REPORT = gql`
    query DaypassReport($travel_date_range: DateRangeInput!, $page: ReportPageInput!) {
        daypassReport(travel_date_range: $travel_date_range, page: $page) {
            code
            success
            message
            total_count
            daypass_report {
                travel_date
                total_daypass
                std_booking_count
                gross_revenue
                wallet_spend
                wallet_refunds
                discounts
                net_revenue
                avg_spend_per_booking
            }
            total {
                total_daypass
                gross_revenue
                wallet_refunds
                wallet_spend
                discounts
                net_revenue
                std_booking_count
                avg_spend_per_booking
            }
        }
    }
`

export const GET_TRIP_REPORT = gql`
    query TripReport($tripFilter: TripReportFilterInput!, $page: ReportPageInput!) {
        tripReport(trip_filter: $tripFilter, page: $page) {
            code
            success
            message
            total_count
            trip_report {
                route_id
                trip_id
                route_name {
                    en
                    ar
                }
                trip_date
                scheduled_time
                actual_time
                status {
                    en
                    ar
                }
                captain_name
                captain_name_2
            }
        }
    }
`

export const GET_ROUTE_UTILIZATION_REPORT = gql`
    query RouteUtilizationReport($routeFilter: RouteUtilizationReportFilterInput!, $page: ReportPageInput!) {
        routeUtilizationReport(route_filter: $routeFilter, page: $page) {
            code
            success
            message
            total_count
            trip_utilization_report {
                route_id
                route_name {
                    en
                    ar
                }
                time_period
                total_trips
                start_station {
                    en
                    ar
                }
                end_station {
                    en
                    ar
                }
                total_completed_trips
                total_cancelled_trips
            }
        }
    }
`

export const GET_STATION_REVENUE_REPORT = gql`
    query StationAggregatedRevenueReport($stationFilter: StationRevenueFilterInput!, $page: ReportPageInput!) {
        stationAggregatedRevenueReport(station_filter: $stationFilter, page: $page) {
            code
            success
            message
            total_count
            station_revenue_report {
                station_id
                serial_number
                station_name {
                    en
                    ar
                }
                total_bookings
                total_passengers
                gross_revenue
                wallet_spend
                wallet_refunds
                total_discounts
                net_revenue
                infant_count
                child_count
                adult_count
                senior_count
            }
        }
    }
`

export const GET_BOOKING_TYPES = gql`
    query BookingType($code: String) {
        bookingType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_MASTER_BOAT_ROUTES = gql`
    query GetMasterBoatRoute($page: PageInput!) {
        getMasterBoatRoute(page: $page) {
            code
            success
            message
            total_count
            master_boat_routes {
                master_route_id
                route_name {
                    en
                    ar
                }
            }
        }
    }
`

export const GET_BOAT_ROUTE_TRIP_STATUS = gql`
    query BoatRouteTripStatus($code: String) {
        boatRouteTripStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_FLEET_UTILIZATION_REPORT = gql`
    query FleetUtilizationReport($fleetFilter: FleetUtilizationFilterInput!, $page: ReportPageInput!) {
        fleetUtilizationReport(fleet_filter: $fleetFilter, page: $page) {
            code
            success
            message
            total_count
            fleet_utilization_report {
                boat_id
                total_trips
                boat_name {
                    en
                    ar
                }
                reg_number
                operational_hours
                ideal_time
            }
        }
    }
`

export const GET_HOURLY_BOOKING_STATISTICS = gql`
    query HourlyBookingStatistics($startDate: LocalDate!, $endDate: LocalDate!) {
        hourlyBookingStatistics(start_date: $startDate, end_date: $endDate) {
            code
            success
            message
            booking_statistics {
                booking_hour
                booking_hour_label
                total_bookings
                total_passengers
                total_trips
            }
        }
    }
`

export const GET_CUSTOMER_FEEDBACK_REPORT = gql`
    query CustomerFeedbackReport($feedbackFilter: CustomerFeedbackFilterInput!, $page: ReportPageInput!) {
        customerFeedbackReport(feedback_filter: $feedbackFilter, page: $page) {
            code
            success
            message
            total_count
            feedback_report {
                feedback_id
                feedback_date
                travel_date
                resolved_date
                resolution_status
                rating
            }
        }
    }
`

export const GET_PAYMENT_METHODS = gql`
    query PaymentMethods {
        paymentMethods {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_ROUTE_TYPES = gql`
    query RouteType($code: String) {
        routeType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_ROUTES_FOR_REPORTS = gql`
    query GetBoatRouteWithTripDetails($page: PageInput!, $routeId: String, $routeName: String, $statusCode: String) {
        getBoatRoute(page: $page, route_id: $routeId, route_name: $routeName, status_code: $statusCode) {
            code
            success
            message
            total_count
            boat_routes {
                route_id
                route_name {
                    en
                    ar
                }
                master_route {
                    route_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                }
                route_trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                }
            }
        }
    }
`

export const GET_NATIONALITY_WISE_PASSENGER_REPORT = gql`
    query Nationality($filter: NationalityWisePassengerFilterInput!, $page: ReportPageInput!) {
        nationalityWisePassengerReport(filter: $filter, page: $page) {
            nationality_wise_passenger_report {
                nationality {
                    alpha_iso2
                    country
                    country_ar
                    is_gcc
                }
                travel_date
                start_station {
                    en
                    ar
                }
                end_station {
                    en
                    ar
                }
                total_passengers
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
            code
            success
            message
            total_count
        }
    }
`
export const GET_EXPLORE_ITEMS_CLICKS_REPORT = gql`
    query userItemClickReport(
        $item_id: NonEmptyString
        $item_category: NonEmptyString!
        $start_date: Date!
        $end_date: Date!
        $page: ReportPageInput!
        $countryCode: NonEmptyString
    ) {
        userItemClickReport(
            item_id: $item_id
            item_category: $item_category
            start_date: $start_date
            end_date: $end_date
            page: $page
            country_code: $countryCode
        ) {
            code
            success
            message
            total_count
            user_item_click_report {
                item_id
                item_title {
                    en
                    ar
                }
                category_code
                category_description {
                    en
                    ar
                }
                click_date
                total_clicks
                mobile_clicks
                web_clicks
                guest_clicks
                registered_clicks
                country_code
            }
        }
    }
`

export const GET_APP_BANNER_REPORT = gql`
    query bannerClickReport(
        $item_id: NonEmptyString
        $item_category: NonEmptyString
        $start_date: Date!
        $end_date: Date!
        $page: ReportPageInput!
    ) {
        bannerClickReport(
            item_id: $item_id
            item_category: $item_category
            start_date: $start_date
            end_date: $end_date
            page: $page
        ) {
            code
            success
            message
            total_count
            banner_click_report {
                item_id
                item_title
                category_code
                click_date
                total_clicks
                mobile_clicks
                web_clicks
                guest_clicks
                registered_clicks
            }
        }
    }
`
